import getOrCreateCustomerId from '@lib/customer';
import fetchApi from '@lib/fetchApi';
import getConfigProps from '@lib/getConfigProps';
import { getBanner, getMatchmakerPage } from '@lib/prepr';
import { matchmakerType } from '@lib/proptypes';
import Matchmaker from '@organisms/Matchmaker/Matchmaker';

export default function MatchmakerPage({ page }) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Matchmaker {...page} />;
}

export async function getServerSideProps(ctx) {
  const { req, locale, preview = false } = ctx;

  const customerId = getOrCreateCustomerId(req);
  const { host } = req.headers;

  const pageBanner = getBanner({ host, locale, customerId, preview });

  const [
    banner,
    page,
    {
      props: { config },
    },
    { data: filters } = { data: [] },
  ] = await Promise.all([
    pageBanner,
    getMatchmakerPage({ host, locale, customerId, preview }),
    getConfigProps(ctx),
    fetchApi({
      path: '/vacancies/all-filter-options',
    }).then(response => response),
  ]);

  const hideBanner =
    banner.items.length && ctx?.req?.cookies.hideBanner === banner.items[0].id;

  if (!page || !config) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      page: {
        ...page,
        filters,
      },
      banner,
      hideBanner,
      config,
      host,
      customerId,
    },
  };
}

MatchmakerPage.propTypes = {
  page: matchmakerType,
};
